<sw-page class="topdata-es-filter-map-list-page">
    <template #smart-bar-header>
        <h2>{{ $tc('TopdataEnhancedSearchSW6.topdata-es-filter-map.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button variant="primary" @click="onAddFilter">
            {{ $tc('TopdataEnhancedSearchSW6.topdata-es-filter-map.buttonAdd') }}
        </sw-button>
    </template>

    <template #content>
        <sw-entity-listing
            v-if="items"
            :dataSource="items"
            :columns="columns"
            :repository="repository"
            identifier="topdata-es-filter-map"
            :show-settings="true"
            :show-selection="false"
            :allow-view="false"
            :allow-edit="false"
            :allow-delete="true"
            :allow-inline-edit="false"
            :full-page="true"
            :sort-by="sortBy"
            :sort-direction="sortDirection"
            :is-loading="isLoading"
            @page-change="onPageChange"
            @column-sort="onSortColumn"
        >
            <template #column-createdAt="{ item }">
                <sw-time-ago :date="item.createdAt" :date-time-format="{ month: '2-digit', day: '2-digit' }" />
            </template>

            <template #actions="{ item }">
                <sw-context-menu-item @click="onEditFilter(item)">
                    {{ $tc('global.default.edit') }}
                </sw-context-menu-item>
                <sw-context-menu-item variant="danger" @click="onShowDeleteModal(item)">
                    {{ $tc('global.default.delete') }}
                </sw-context-menu-item>
            </template>
        </sw-entity-listing>

        <sw-confirm-modal
            v-if="showDeleteModal"
            :title="$tc('global.default.delete')"
            :text="deleteConfirmText"
            :confirmButtonVariant="'danger'"
            @confirm="onConfirmDelete"
            @close="onCloseDeleteModal"
            @cancel="onCloseDeleteModal"
        />

        <topdata-es-filter-map-form
            v-if="activeModal"
            :entity="currentEntity"
            :repository="repository"
            @save="onCloseModal"
            @cancel="onCloseModal"
        />
    </template>
</sw-page>